import { barBasketContent} from "../barBasketContent/barBasketContent";
import { langChanger} from "../langChanger/langChanger";

import './less/topBar.less';

const topBar = (function(){

})()

export { topBar };


// WEBPACK FOOTER //
// ./components/topBar/topBar.js